import { makeObservable } from 'mobx'
import type { MobxDocument } from '../firestore-mobx'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import type { FirebaseRepository } from './FirebaseRepository'
import { empty } from '../firestore/SettingsDeadAirDetector/schema'
import type { FirestoreSettingsDeadAirDetector } from '../firestore/SettingsDeadAirDetector/schema'

export class SettingsDeadAirDetector extends ObservableModelWithDecorators<FirestoreSettingsDeadAirDetector> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreSettingsDeadAirDetector>
  ) {
    super(repository, doc)

    makeObservable(this)
  }

  // Returns the defaults if data is not set for any reason.
  get settings() {
    return this.data || empty
  }
}
